import Vue from "vue";

import "./assets/icon/iconFont.css"; // 字体图标
import "./assets/css/common.css"; // 公共样式
import "./assets/css/animate.css"; // 动画

import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/them.less";

import api from "@/api";

// 忽略 ResizeObserver loop limit exceeded 错误
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

Vue.use(ElementUI);
Vue.prototype.$api = api;
Vue.prototype.getEduDomain = function() {
  return location.protocol + '//' + (window?.orginfo?.orgDomain || process.env.VUE_APP_EDU_URL);
}

Vue.prototype.hasPermission = function(permission) {
  return store.state.userRole.includes(permission);
}

Vue.prototype.qs = function(str) {
  if(!str) {
    return {}
  }

  return JSON.parse(`{ "${ str.replaceAll('&', '","').replaceAll('=', '":"') }" }`)
}

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive("real-img", async function(el, binding) {
  let imgURL = binding.value; //获取图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute("src", imgURL);
    }
  }
});


// 设置logo
if (!window.apiBaseUrl) window.apiBaseUrl = process.env.VUE_APP_API_URL;

api.getDomainInfo(window.location.host).then(res => {
  let orginfo = res.data || {};

  window.orginfo = orginfo;
  if (orginfo.orgDomainRecord)
    window.orgDomainRecord = orginfo.orgDomainRecord;
  if (orginfo.logoUrl) {
    window.logoUrl = orginfo.logoUrl + "&v=" + orginfo.updateTime;
  }
  if (orginfo.icoUrl) {
    document.querySelector("link").href =
      orginfo.icoUrl + "&v=" + orginfo.updateTime;
  }
  if (orginfo.logoWhiteUrl) {
    window.logoWhiteUrl = orginfo.logoWhiteUrl + "&v=" + orginfo.updateTime;
    if (document.querySelector('img[class^="menu-bar_scratch-logo_"]'))
      document.querySelector('img[class^="menu-bar_scratch-logo_"]').src =
        orginfo.logoWhiteUrl + "&v=" + orginfo.updateTime;
  }
  if (orginfo.name) {
    document.title = orginfo.name;
    if (document.querySelector(".windowName")) {
      document.querySelector(".windowName").innerText = orginfo.name;
    }
  }

  if (orginfo.qrcodeUrl) {
    window.qrCodeUrl = orginfo.qrcodeUrl;
  }
}).finally(() => {
  renderApp();
})


let imageIsExist = function(url) {
  return new Promise((resolve) => {
    var img = new Image();
    img.onload = function() {
      if (this.complete == true) {
        resolve(true);
        img = null;
      }
    };
    img.onerror = function() {
      resolve(false);
      img = null;
    };
    img.src = url;
  });
};

// Vue.config.productionTip = false;

function renderApp() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
